import { IAccount } from 'interfaces/accounts';
import { BehaviorSubject, Observable } from 'rxjs';
import rxjsOperators from 'rxjs-operators';
import authService from './auth';
import * as rxjs from 'rxjs';

export class UserService {
  private accounts$ = new BehaviorSubject<IAccount[]>([]);

  constructor() {
    this.updateIsMe();
  }
  public getAccounts(): Observable<IAccount[]> {
    return this.accounts$.asObservable();
  }

  public setAccounts(accounts: IAccount[]) {
    this.accounts$.next(accounts);
  }

  private updateIsMe() {
    rxjs
      .combineLatest([this.getAccounts(), authService.getUser()])
      .pipe(
        rxjsOperators.filter(([accounts, user]) => accounts?.length > 1 && Boolean(user)),
        rxjsOperators.tap(([accounts, user]) => {
          const indexAccountLogged = accounts.findIndex(account => account?.isMe);
          const indexAccountTarget = accounts.findIndex(account => account?.id === user?.id);

          if (indexAccountLogged !== indexAccountTarget) {
            const newAccounts = accounts;

            newAccounts[indexAccountLogged].isMe = false;
            newAccounts[indexAccountTarget].isMe = true;

            this.setAccounts(newAccounts);
          }
        })
      )
      .subscribe();
  }
}

const userService = new UserService();
export default userService;
